import { render } from "./ListQuestions.vue?vue&type=template&id=349ce61e"
import script from "./ListQuestions.vue?vue&type=script&lang=ts"
export * from "./ListQuestions.vue?vue&type=script&lang=ts"
script.render = render

export default script